import React, { Component } from 'react';
import './Account.css'
//import DashboardCard from './DashboardCard'
import {
    Card,
    Descriptions,
    Row,
    Col,
    Button,
    Modal,
    Form,
    Input,
    Typography,
    Statistic,
    Avatar,
    Tag,
    Progress,
    Table,
} from 'antd'
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    InboxOutlined,
    HomeOutlined,
    MailOutlined,
    UserOutlined,
    PhoneOutlined,
    EditOutlined,
    PlusOutlined
} from '@ant-design/icons';
import { Link, } from 'react-router-dom';
import AccountHeader from './AccountHeader';
import { GET_BIND_APARTMENT, GET_POSSESS_LIST, GET_USER_STAT_URL, GET_DEPT_LIST, get_data_token, BIND_APARTMENT, CANCELBIND_APARTMENT, GET_TRANSACTION_LIST, GET_RESERVE_LIST } from '../../config/network'
import { showErrorMessage } from '../MessageBox'
import { FormattedMessage } from 'react-intl';

const { Title, Text } = Typography;

class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            memberinfo: {},
            memberprofile: {},
            statusdetail: {},
            isProfilecompleted: '',
            isEmailVerified: '',
            hasBindAddress: '',
            transactions: [],
            productsinprocession: [],
            deptzipcode: '',
            bindzipcodevisible: false,
            selectDeptvisible: false,
            ModalText: 'Please input your zipcode first',
            deptlist: [],
            selecteddept: '',
            records: [],
            apartments: [],
            load: false,
            loadapartment: false,
            loadzipcode: false,
            loaddepartment: false,
            //
            cancelbinddept: '',
            cancelbindzipcodevisible: false,
            loadcancel: false,
            recentActivities: [],
            loadingActivities: false,
        };
        this.showModal = this.showModal.bind(this);
        this.cancelshowModal = this.cancelshowModal.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDeptSubmit = this.handleDeptSubmit.bind(this);
        this.handlezipcodeSubmit = this.handlezipcodeSubmit.bind(this);
        this.handlezipcodeChange = this.handlezipcodeChange.bind(this);
        this.getTransactions = this.getTransactions.bind(this);
        this.getApartment = this.getApartment.bind(this);
        //
        this.handlecanceldeptChange = this.handlecanceldeptChange.bind(this);
        this.handlecancelbindSubmit = this.handlecancelbindSubmit.bind(this);
        this.getRecentActivities = this.getRecentActivities.bind(this);

    }
    //
    cancelshowModal = () => {
        this.setState({
            //ModalText: 'Please input your departmentID',
            ModalText: '',
            cancelbinddept: '',
            cancelbindzipcodevisible: true,
            loadcancel: false,
        });
    };
    //
    showModal = () => {
        this.setState({
            //ModalText: 'Please input your zipcode first',
            ModalText: '',
            deptzipcode: '',
            bindzipcodevisible: true,
            loadzipcode: false,
        });
    };
    //cancel杈撳叆浜嬩欢
    handlecanceldeptChange(event) {
        this.setState({ cancelbinddept: event.target.value, loadcancel: false, });
    }
    //
    rendercancelbind() {
        if (this.state.loadcancel)
            return <h5>Loading...</h5>;

        return (
            <Modal
                title="Input your bound Organization ID"
                open={this.state.cancelbindzipcodevisible}
                onOk={this.handlecancelbindSubmit}
                onCancel={this.handleCancel}
            >
                <Form >
                    <Form.Item label="organizationid">
                        <Input type="text" value={this.state.cancelbinddept} onChange={this.handlecanceldeptChange} />
                    </Form.Item>
                </Form>
                <p>{this.state.ModalText}</p>
            </Modal>
        )
    }
    //cancelbind鐣岄潰 submit浜嬩欢
    handlecancelbindSubmit(event) {
        let deptid = this.state.cancelbinddept;
        if (deptid === undefined) {
            return;
        }
        if (deptid === null) {
            return;
        }
        if (deptid === "") {
            this.setState({
                ModalText: 'Error organizationid,please input again',
                loadcancel: false,
            })
            return;
        }
        get_data_token(CANCELBIND_APARTMENT, { organizationId: deptid })
            .then(
                data => {

                    this.getApartment();
                    this.setState({ cancelbindzipcodevisible: false, loadcancel: false, });
                    return;

                })
            .catch(
                err => showErrorMessage.call(this, 'Cancel Bind organization data error:' + err)
            )
        //
        this.setState({
            ModalText: 'No such organization!',
            loadcancel: false,
        })

    }
    //zipcode鐣岄潰 OK浜嬩欢
    handleOk = () => {
        this.setState({
            ModalText: 'The modal will be closed after two seconds',
            loadzipcode: false,
            //loaddepartment:true,
        });
        setTimeout(() => {
            this.setState({
                deptzipcode: '',
                bindzipcodevisible: false,
                bindDeptvisible: false,
                selectDeptvisible: false,
                cancelbindzipcodevisible: false,
                loaddepartment: false,
                loadzipcode: false,
                loadcancel: false,

            });
        }, 2000);
    };
    //zipcode鐣岄潰 Cancel浜嬩欢
    handleCancel = () => {
        console.log('Clicked cancel button');
        this.setState({
            deptzipcode: '',
            bindzipcodevisible: false,
            selectDeptvisible: false,
            cancelbindzipcodevisible: false,
            loadzipcode: false,
            loaddepartment: false,
            loadcancel: false,
        });
    };
    //
    handleChange(event) {
        this.setState({ selecteddept: event.target.value, loaddepartment: false, });
    }
    //
    handlezipcodeChange(event) {
        this.setState({ deptzipcode: event.target.value, loadzipcode: false, });
    }
    //
    renderZipcode() {

        if (this.state.loadzipcode)
            return <h5>Loading...</h5>;

        return (
            <Modal
                title="Select your zipcode"
                open={this.state.bindzipcodevisible}
                //onOk={this.handleOk}
                onOk={this.handlezipcodeSubmit}
                onCancel={this.handleCancel}
            >
                <Form >
                    <Form.Item label="zipcode">
                        <Input type="text" value={this.state.deptzipcode} onChange={this.handlezipcodeChange} />
                    </Form.Item>
                </Form>
                <p>{this.state.ModalText}</p>
            </Modal>
        )
    }
    //
    renderDepartment() {
        if (this.state.loaddepartment)
            return <h5>Loading...</h5>;
        const deptlist = this.state.deptlist;
        let Deptoptions = deptlist.map((item) =>
            //    <option value={item.apartmentId}>{item.apartmentName}</option>
            <option key={item.value} value={item.value}>{item.key}</option>
        );

        //let selectDeptvisible=this.state.selectDeptvisible;
        return (
            <Modal
                title="Select Department"
                open={this.state.selectDeptvisible}
                //visible={selectDeptvisible}
                //onOk={this.handleOk}
                onOk={this.handleDeptSubmit}
                onCancel={this.handleCancel}
            >
                <Form >
                    <Form.Item label="Department">

                        <select value={this.state.selecteddept} onChange={this.handleChange}>
                            {Deptoptions}
                        </select>
                    </Form.Item>

                </Form>

                <p>{this.state.ModalText}</p>
            </Modal>
        )
    }
    //
    renderApartments() {
        if (this.state.loadapartment)
            return <h5>Loading...</h5>;
        if (this.state.apartments.length === 0)
            return <p>You have not linked your account with any organization yet. please bind your account with a organization.</p>;

        const columns = [
            {
                title: 'Organization ID',
                dataIndex: 'organization_id',
                key: 'organization_id',
            },
            {
                title: 'Organization Name',
                dataIndex: 'organization_name',
                key: 'organization_name',
            },
            {
                title: 'Approve Status',
                dataIndex: 'approve_status',
                key: 'approve_status',
                render: (value) => (value === '1' ? 'approved' : 'to be approve'),
            },
        ];

        return (
            <Table
                columns={columns}
                dataSource={this.state.apartments}
                rowKey={(record) => record.organization_id || record.organization_name}
                pagination={false}
                size="small"
            />
        )
    }
    //
    renderRecords() {
        const columns = [
            {
                title: 'Product Name',
                dataIndex: 'product_name',
                key: 'product_name',
                render: (text) => text || 'N/A'
            },
            {
                title: 'Brand',
                dataIndex: 'brand',
                key: 'brand',
                render: (text) => text || 'N/A'
            },
            {
                title: 'Rental Time',
                dataIndex: 'rental_time',
                key: 'rental_time',
                render: (text) => {
                    if (!text) return 'N/A';
                    // Convert Unix timestamp to readable date
                    const date = new Date(parseInt(text) * 1000);
                    return date.toLocaleString();
                }
            },
            {
                title: 'Status',
                key: 'status',
                render: () => <Tag color="orange">In Possession</Tag>
            }
        ];

        return (
            <Table
                columns={columns}
                dataSource={this.state.records}
                loading={this.state.load}
                pagination={false}
                locale={{
                    emptyText: (
                        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                            <InboxOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
                            <p>You currently have no possessions.</p>
                            <p>Items you rent will appear here.</p>
                        </div>
                    )
                }}
            />
        );
    }
    //zipcode鐣岄潰 submit浜嬩欢
    handlezipcodeSubmit(event) {
        let deptzipcode = this.state.deptzipcode;
        if (deptzipcode === undefined) {
            return;
        }
        if (deptzipcode === null) {
            return;
        }
        if (deptzipcode === "") {
            this.setState({
                ModalText: 'Error zipcode,please input zipcode again',
                loadzipcode: false,
            })
            return;
        }
        get_data_token(GET_DEPT_LIST, { zipcode: deptzipcode })
            .then(

                data => {
                    if (data.apartmentList.length === 0) {
                        this.setState({
                            ModalText: 'Error zipcode,please input zipcode again',
                            loadzipcode: false,
                        })
                        return;
                    }
                    else
                    //
                    {
                        let departmentlistapi = data.apartmentList.map((record, index) => {


                            if (index === 0) {
                                this.setState({ selecteddept: record.organizationId, });
                            }
                            return { value: record.organizationId, key: record.organizationName }
                        });
                        this.setState({
                            ModalText: '',
                            deptlist: departmentlistapi,
                            bindzipcodevisible: false,
                            loadzipcode: false,
                            selectDeptvisible: true,
                            loaddepartment: false,
                        });
                    }
                    //

                })
            .catch(
                err => showErrorMessage.call(this, 'Get department data error:' + err)
            )

    }
    //缁戝畾鎻愪氦
    handleDeptSubmit(event) {
        get_data_token(BIND_APARTMENT, { organizationId: this.state.selecteddept })
            .then(
                data => {

                    this.getApartment();
                    this.setState({ selectDeptvisible: false, loaddepartment: false, });
                    return;

                })
            .catch(
                err => showErrorMessage.call(this, 'Bind organization data error:' + err)
            )
        //
        this.setState({
            ModalText: 'You have bound to this organization already!',
            loaddepartment: false,
        })

    }

    // handleDeptChange(event) {

    //     this.setState({ selecteddept: event.target.value,loaddepartment:false, });


    // }
    componentDidMount() {
        if (localStorage.getItem('accessToken') == null) {
            this.setState({ reload: true });
            return;
        }
        get_data_token(GET_USER_STAT_URL, {})
            .then(data => {
                this.setState({
                    memberinfo: data.member,
                    memberprofile: data.profile,
                    isProfileCompleted: data.member.statusDetail.isProfileCompleted,
                    hasBindAddress: data.member.statusDetail.hasBindAddress,
                })
                //departmentid
                this.getApartment();
                //
                this.getTransactions();
                this.getRecentActivities();
            })
            .catch(err => showErrorMessage.call(this, 'Get user statistics error:' + err))
    }
    //
    getApartment() {
        this.setState({ loadapartment: true })
        get_data_token(GET_BIND_APARTMENT, {})
            .then(data => {
                data.map(record => record.key);
                this.setState({ apartments: data, loadapartment: false });
            })
            .catch(err => {
                this.setState({ apartments: [], loadapartment: false });
                showErrorMessage.call(this, 'Get apartment error:' + err);
            })
    }
    //
    getTransactions() {
        this.setState({ load: true })
        get_data_token(GET_POSSESS_LIST, {})
            .then(data => {
                if (data && data.data && Array.isArray(data.data)) {
                    const possessRecords = data.data.map((record, index) => ({
                        ...record,
                        key: record.rental_id || record.rental_time || index,
                        rental_id: record.rental_id || index,
                        cabinet_id: record.cabinet_id || 'N/A',
                        box_id: record.box_id || 'N/A'
                    }));
                    this.setState({ records: possessRecords, load: false });
                } else {
                    this.setState({ records: [], load: false });
                }
            })
            .catch(err => {
                this.setState({ records: [], load: false });
                showErrorMessage.call(this, 'Get possessions error:' + err);
            })
    }

    //
    getRecentActivities() {
        this.setState({ loadingActivities: true });

        // Get date 3 months ago
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        const startTime = threeMonthsAgo.getTime() / 1000;
        const endTime = new Date().getTime() / 1000;

        // Fetch both transactions and reservations
        const transactionPromise = get_data_token(GET_TRANSACTION_LIST, {
            startime: startTime,
            endtime: endTime,
        }).catch(() => ({ data: [] })); // Return empty data on error

        const reservationPromise = get_data_token(GET_RESERVE_LIST, {
            startime: startTime,
            endtime: endTime,
        }).catch(() => ({ data: [] })); // Return empty data on error

        Promise.all([transactionPromise, reservationPromise])
            .then(([transactionResponse, reservationResponse]) => {
                const transactions = (transactionResponse.data || transactionResponse.transactionList || transactionResponse.storeList || [])
                    .map(item => ({
                        ...item,
                        type: 'transaction',
                        time: item.rental_time || item.storeTime,
                        id: item.rental_id || item.storeId,
                        title: item.product_name || 'Package Transaction',
                        rental_time: item.rental_time || item.storeTime,
                        return_time: item.return_time || item.pickTime,
                        description: `Cabinet: ${item.cabinet_id || item.cabinetId || 'N/A'}`
                    }));

                const reservations = (reservationResponse.data || reservationResponse.reserveList || reservationResponse.storeList || [])
                    .map(item => ({
                        ...item,
                        type: 'reservation',
                        time: item.reserve_time || item.storeTime,
                        id: item.reserve_id || item.rental_id || item.storeId,
                        title: item.product_name || item.productName || 'Package Reservation',
                        rental_time: item.reserve_time || item.storeTime,
                        return_time: null, // Reservations don't have return time
                        description: `Cabinet: ${item.cabinet_id || item.cabinetId}, Status: Reserved`
                    }));

                // Combine and sort by time (most recent first)
                const allActivities = [...transactions, ...reservations]
                    .filter(item => item.time) // Filter out items without time
                    .sort((a, b) => b.time - a.time)
                    .slice(0, 10); // Take only the latest 10

                this.setState({
                    recentActivities: allActivities,
                    loadingActivities: false
                });
            })
            .catch(err => {
                this.setState({
                    recentActivities: [],
                    loadingActivities: false
                });
                console.error('Get recent activities error:', err);
            });
    }

    //

    //
    render() {
        const memberinfo = this.state.memberinfo;
        const memberprofile = this.state.memberprofile;

        const profileComplete = memberinfo.statusDetail && memberinfo.statusDetail.isProfileCompleted === 1;
        const isEmailVerified = memberinfo.statusDetail &&
            (memberinfo.statusDetail.isEmailVerified === 1 || memberinfo.statusDetail.isEmailVerified === "1");

        return (
            <div className="dashboard-container">
                <AccountHeader page={"Account"}
                    title={<FormattedMessage id="page.sidnav.title.Dashboard" defaultMessage="Dashboard" />}
                />

                <div className="dashboard-content">
                    {/* Welcome Section */}
                    <div className="welcome-section">
                        <Row gutter={[24, 24]}>
                            <Col xs={24} md={16}>
                                <Card className="welcome-card" bordered={false}>
                                    <div className="welcome-content">
                                        <Avatar size={64} icon={<UserOutlined />} className="welcome-avatar" />
                                        <div className="welcome-text">
                                            <Title level={2} className="welcome-title">
                                                Welcome back, {memberprofile.firstName || 'User'}!
                                            </Title>
                                            <Text className="welcome-subtitle">
                                                Here's what's happening with your account today.
                                            </Text>
                                        </div>
                                    </div>
                                </Card>
                            </Col>
                            <Col xs={24} md={8}>
                                <Card className="quick-actions-card" bordered={false}>
                                    <Title level={4}>Quick Actions</Title>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <Link to="/account/profile">
                                            <Button type="primary" icon={<EditOutlined />} block>
                                                Update Profile
                                            </Button>
                                        </Link>
                                        <Button
                                            type="default"
                                            icon={<PlusOutlined />}
                                            onClick={this.showModal}
                                            block
                                        >
                                            Subscribe Organization
                                        </Button>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    {/* Status Cards */}
                    <Row gutter={[24, 24]} className="status-cards">
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Profile Status"
                                    value={profileComplete ? "Complete" : "Incomplete"}
                                    prefix={<CheckCircleOutlined style={{ color: profileComplete ? '#52c41a' : '#faad14' }} />}
                                    valueStyle={{ color: profileComplete ? '#52c41a' : '#faad14' }}
                                />
                                <Progress
                                    percent={profileComplete ? 100 : 60}
                                    size="small"
                                    status={profileComplete ? "success" : "active"}
                                    style={{ marginTop: 8 }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Possessions"
                                    value={this.state.records.length}
                                    prefix={<InboxOutlined style={{ color: '#1890ff' }} />}
                                    valueStyle={{ color: '#1890ff' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Organizations"
                                    value={this.state.apartments.length}
                                    prefix={<HomeOutlined style={{ color: '#722ed1' }} />}
                                    valueStyle={{ color: '#722ed1' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Email Status"
                                    value={isEmailVerified ? "Verified" : "Pending"}
                                    prefix={<MailOutlined style={{ color: isEmailVerified ? '#52c41a' : '#faad14' }} />}
                                    valueStyle={{ color: isEmailVerified ? '#52c41a' : '#faad14' }}
                                />
                            </Card>
                        </Col>
                    </Row>

                    {/* Main Content */}
                    <Row gutter={[24, 24]}>
                        {/* User Profile Section */}
                        <Col xs={24} lg={12}>
                            <Card
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <UserOutlined />
                                        <span>Profile Information</span>
                                    </div>
                                }
                                extra={
                                    <Link to="/account/profile">
                                        <Button type="link" icon={<EditOutlined />}>
                                            Edit
                                        </Button>
                                    </Link>
                                }
                                className="profile-card"
                            >
                                <Descriptions column={1} size="small">
                                    <Descriptions.Item label="Email">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <MailOutlined />
                                            {memberinfo.email}
                                            {isEmailVerified &&
                                                <Tag color="green"><CheckCircleOutlined />Verified</Tag>
                                            }
                                        </div>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Phone">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <PhoneOutlined />
                                            {memberinfo.phone || 'Not provided'}
                                        </div>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Name">
                                        {memberprofile.firstName} {memberprofile.lastName}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Address">
                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                            <HomeOutlined />
                                            <div>
                                                {memberprofile.addressline1}<br />
                                                {memberprofile.addressline2 && (
                                                    <>{memberprofile.addressline2}<br /></>
                                                )}
                                                {memberprofile.city} {memberprofile.state} {memberprofile.zipcode}
                                            </div>
                                        </div>
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>
                        </Col>

                        {/* Organizations Section */}
                        <Col xs={24} lg={12}>
                            <Card
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <HomeOutlined />
                                        <span>Subscribed Organizations</span>
                                    </div>
                                }
                                extra={
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <Button
                                            type="primary"
                                            size="small"
                                            icon={<PlusOutlined />}
                                            onClick={this.showModal}
                                        >
                                            Subscribe
                                        </Button>
                                        <Button
                                            danger
                                            size="small"
                                            onClick={this.cancelshowModal}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                }
                                className="apartments-card"
                            >
                                {this.renderApartments()}
                                {this.renderZipcode()}
                                {this.renderDepartment()}
                                {this.rendercancelbind()}
                            </Card>
                        </Col>
                    </Row>

                    {/* Current Possessions */}
                    <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
                        <Col span={24}>
                            <Card
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <InboxOutlined />
                                        <span>Your Current Possessions</span>
                                    </div>
                                }
                                className="packages-card"
                            >
                                {this.renderRecords()}
                            </Card>
                        </Col>
                    </Row>

                    {/* Transaction History */}
                    <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
                        <Col span={24}>
                            <Card
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <ClockCircleOutlined />
                                        <span>Recent Activity (Last 3 Months)</span>
                                    </div>
                                }
                                extra={
                                    <Link to="/account/transactions">
                                        <Button type="link" icon={<EditOutlined />}>
                                            View All
                                        </Button>
                                    </Link>
                                }
                                className="transactions-card"
                            >
                                {this.state.loadingActivities ? (
                                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                                        <ClockCircleOutlined style={{ fontSize: '48px', color: '#1890ff' }} spin />
                                        <div style={{ marginTop: '16px', color: '#1890ff' }}>
                                            Loading recent activities...
                                        </div>
                                    </div>
                                ) : this.state.recentActivities.length === 0 ? (
                                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                                        <ClockCircleOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />
                                        <div style={{ marginTop: '16px', color: '#999' }}>
                                            No recent activities
                                        </div>
                                        <div style={{ marginTop: '16px' }}>
                                            <Link to="/account/transactions">
                                                <Button type="primary">View Transaction History</Button>
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <Table
                                        dataSource={this.state.recentActivities}
                                        rowKey="id"
                                        pagination={false}
                                        size="small"
                                        columns={[
                                            {
                                                title: 'ID',
                                                dataIndex: 'id',
                                                key: 'id',
                                                render: (text) => <Tag color="blue">{text}</Tag>
                                            },
                                            {
                                                title: 'Product Name',
                                                dataIndex: 'title',
                                                key: 'title',
                                                render: (text) => <strong>{text}</strong>
                                            },
                                            {
                                                title: 'Rent Time',
                                                dataIndex: 'rental_time',
                                                key: 'rental_time',
                                                render: (text, record) => {
                                                    const rentTime = text || record.time || record.storeTime;
                                                    return rentTime ? new Date(rentTime * 1000).toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'short',
                                                        day: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    }) : 'N/A';
                                                }
                                            },
                                            {
                                                title: 'Return Time',
                                                dataIndex: 'return_time',
                                                key: 'return_time',
                                                render: (text, record) => {
                                                    if (record.type === 'reservation') {
                                                        return <Tag color="orange">Reserved</Tag>;
                                                    }
                                                    return text ? new Date(text * 1000).toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'short',
                                                        day: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    }) : 'Not Returned';
                                                }
                                            },
                                            {
                                                title: 'Type',
                                                dataIndex: 'type',
                                                key: 'type',
                                                render: (text) => (
                                                    <Tag color={text === 'transaction' ? 'green' : 'orange'}>
                                                        {text === 'transaction' ? 'Transaction' : 'Reservation'}
                                                    </Tag>
                                                )
                                            }
                                        ]}
                                    />
                                )}
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default Account;
